export const getValidationConfig = (validationConfig, fieldValidationConfig) => {
    return Object.assign(Object.assign({}, validationConfig), { password: fieldValidationConfig.password });
};
//# sourceMappingURL=get-validation-config.js.map